export const normalizeDomainInput = (value) => {
  let domain = value.trim().toLowerCase();
  domain = domain.replace(/^https?:\/\//, '');
  domain = domain.replace(/^www\./, '');
  domain = domain.split(/[/?#]/)[0];
  domain = domain.split(':')[0];
  return domain.replace(/\.$/, '');
};

export const isValidDomain = (domain) => {
  if (!domain || domain.length > 253 || !domain.includes('.')) return false;
  return domain
    .split('.')
    .every((label) => label.length > 0 && label.length <= 63 && /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(label));
};
